module.exports = __webpack_public_path__ + "img/copiar.dff467f0.svg";